import React from "react";
import { connect } from "react-redux";
import AlbumCard from "../../common/components/AlbumCard/AlbumCard";
import SwiperList from "./../../common/components/SwiperList/SwiperList";
import "./style.scss";
function AlbumSliderContainer({ albums }) {
  return (
    <div style={{ width: "100%" }} className="album-slideer_container">
      <SwiperList slides={albums} slideEl={<AlbumCard />} />
    </div>
  );
}
const mapStateToProps = (state, ownProps) => {
  return {
    albums: state.albums,
  };
};

export default connect(mapStateToProps)(AlbumSliderContainer);
